/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { AlarmTypeService } from './AlarmTypeService';

class AlarmTypeServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AlarmTypeService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AlarmTypeServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmTypeServiceProvider.js